import { render, staticRenderFns } from "./ReleasePromotionalTextsEditPanel.vue?vue&type=template&id=4cfd861c"
import script from "./ReleasePromotionalTextsEditPanel.vue?vue&type=script&lang=js"
export * from "./ReleasePromotionalTextsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./ReleasePromotionalTextsEditPanel.vue?vue&type=style&index=0&id=4cfd861c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports